// src/components/common/Toast.js
import { useState, useEffect } from 'react';
import { CheckCircleIcon, XCircleIcon, ExclamationTriangleIcon, InformationCircleIcon, XMarkIcon } from '@heroicons/react/24/solid';
import GlassyIcon from './GlassyIcon';

const icons = {
  success: <GlassyIcon icon={CheckCircleIcon} size="sm" color="green" />,
  error: <GlassyIcon icon={XCircleIcon} size="sm" color="red" />,
  warning: <GlassyIcon icon={ExclamationTriangleIcon} size="sm" color="amber" />,
  info: <GlassyIcon icon={InformationCircleIcon} size="sm" color="blue" />,
};

const Toast = ({ message, type = 'info', show, onClose, duration = 5000 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timeout;
    if (show) {
      setIsVisible(true);
      timeout = setTimeout(() => {
        onClose();
      }, duration);
    } else {
      setIsVisible(false);
    }
    return () => clearTimeout(timeout);
  }, [show, onClose, duration]);

  return (
    <div aria-live="assertive" className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-end z-[100]">
      <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
        <div
          className={`w-full max-w-sm transform transition-all duration-300 ease-in-out ${
            isVisible ? 'translate-y-0 opacity-100 pointer-events-auto' : 'translate-y-5 opacity-0 pointer-events-none'
          }`}
        >
          <div className="relative backdrop-blur-sm border border-white/20 rounded-xl shadow-lg p-4 bg-gradient-to-br from-white/10 to-transparent dark:from-white/5">
            <div className="flex items-start relative z-10">
              <div className="flex-shrink-0">{icons[type]}</div>
              <div className="ml-3 w-0 flex-1 pt-0.5">
                <p className="text-sm font-medium text-gray-900 dark:text-white drop-shadow-sm">{message}</p>
              </div>
              <div className="ml-4 flex flex-shrink-0">
                <button
                  onClick={onClose}
                  className="inline-flex rounded-md backdrop-blur-sm border border-white/20 bg-white/30 text-gray-700 dark:text-white/90 hover:text-gray-900 dark:hover:text-white hover:bg-white/50 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:focus:ring-white/50 transition-all duration-200"
                >
                  <span className="sr-only">Close</span>
                  <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toast;